import React, { useContext, useReducer, useEffect } from 'react';
import { Field, Form, FormSpy } from 'react-final-form';
import * as PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import toast from 'react-hot-toast';
import Select from 'react-select';
import {
  FormButtonToolbar,
  FormContainer,
  FormGroup,
  FormGroupField,
  FormGroupLabel,
} from '@/shared/components/form/FormElements';
import {
  TextField,
} from '@mui/material';
import { Button } from '@/shared/components/Button';
import { AuthContext } from '../../../context/AuthContext';
 
// Define action types for the reducer
const ACTIONS = {
  SET_AMOUNT: 'set_amount',
  ADD_AMOUNT: 'add_amount',
  SET_PAYMENT_TYPE: 'set_payment_type',
  SET_FORM_VALUES: 'set_form_values',
};
 
// Initial state for the reducer
const initialState = {
  amount: 0,
  selectPaymentType: null,
  formValues: {
    recAmount: 0,
    receivedDate: new Date(),
    chequeDate: new Date(),
    narration: '',
    ref: '',
    bankName: '',
  },
};
 
// Reducer function to handle state updates
const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_AMOUNT:
      return {
        ...state,
        amount: action.payload,
        formValues: {
          ...state.formValues,
          recAmount: action.payload,
        },
      };
    case ACTIONS.ADD_AMOUNT:
      // eslint-disable-next-line
      const newAmount = state.amount + action.payload;
      return {
        ...state,
        amount: newAmount,
        formValues: {
          ...state.formValues,
          recAmount: newAmount,
        },
      };
    case ACTIONS.SET_PAYMENT_TYPE:
      return { ...state, selectPaymentType: action.payload };
    case ACTIONS.SET_FORM_VALUES:
      return { ...state, formValues: { ...state.formValues, ...action.payload } };
    default:
      return state;
  }
};
 
const AddAmount = ({ handleAccountSubmit, balance, setShowAddAmountModal }) => {
  // Using useReducer instead of multiple useState calls
  const [state, dispatch] = useReducer(reducer, initialState);
  const { amount, selectPaymentType, formValues } = state;
  // const { agentId, userId, apiGlobal } = useContext(AuthContext);
 
  // const handleAddAmount = (valueToAdd) => {
  //   dispatch({ type: ACTIONS.ADD_AMOUNT, payload: valueToAdd });
  // };
 
  // const handleInputChange = (e) => {
  //   const value = parseFloat(e.target.value);
  //   dispatch({ type: ACTIONS.SET_AMOUNT, payload: Number.isNaN(value) ? 0 : value });
  // };
 
  // const formatNumber = num => new Intl.NumberFormat().format(num);
 
  // const buttonValues = [2000, 5000, 10000, 50000, 100000];
 
  const paymentTypeOptions = [
    { value: '1', label: 'Cash' },
    // { value: '2', label: 'Pay now' },
    { value: '3', label: 'NEFT/RTGS/IMPS' },
    { value: '5', label: 'Cheque' },
  ];



 
  return (
    <Form
      onSubmit={handleAccountSubmit}
      initialValues={{ selectPaymentType, balance }}
    >
      {({ handleSubmit, form }) => (
        <FormContainer onSubmit={handleSubmit}>
          {/* Form Spy to keep track of form values without re-rendering */}
          <FormSpy
            subscription={{ values: true }}
            onChange={(formState) => {
                // Only track form values without causing re-renders
                dispatch({
                  type: ACTIONS.SET_FORM_VALUES,
                  payload: formState.values,
                });
              }}
          />
          <Field
            name="balance"
            component="input"
            type="text"
            style={{
                display: 'none',
              }}
            // initialValue={balance !== 0 ? balance : undefined}
          />
          <div className="row col-md-12">
            {/* Payment Type Field - Always show this first */}
            <div className="col-md-4">
              <FormGroup>
                <FormGroupLabel>
                  Payment Type<span style={{ color: 'red' }}>*</span>
                </FormGroupLabel>
                <div className="custom-select-wrapper">
                  <Select
                    className="react-select"
                    classNamePrefix="react-select"
                    options={paymentTypeOptions}
                    isClearable
                    placeholder="Payment Type"
                    value={selectPaymentType}
                    onChange={(option) => {
                        dispatch({ type: ACTIONS.SET_PAYMENT_TYPE, payload: option });
                      }}
                  />
                  {!selectPaymentType && (
                  <div className="text-danger mt-1" style={{ fontSize: '0.8rem' }}>
                    Please select payment type
                  </div>
                    )}
                </div>
              </FormGroup>
            </div>
            
            {/* Only render the following fields if a payment type is selected */}
            {selectPaymentType && (
            <>
              {/* Payment Date Field - show for Cash, NEFT/RTGS, and Cheque */}
              {['1', '3', '5'].includes(selectPaymentType.value) && (
              <div className="col-md-4">
                <FormGroup>
                  <FormGroupLabel>
                    Payment Date<span style={{ color: 'red' }}>*</span>
                  </FormGroupLabel>
                  <FormGroupField>
                    <Field
                      name="receivedDate"
                      render={({ input }) => (
                        // <DatePicker
                        //   {...input}
                        //   selected={input.value ? new Date(input.value) : new Date()}
                        //   onChange={date => input.onChange(date)}
                        //   dateFormat="dd-MM-yyyy"
                        //   className="form-control"
                        //   style={{
                        //   width: '100%',
                        //   height: '52px', // Increased height
                        //   fontSize: '1rem', // Larger font
                        //   padding: '10px', // More padding
                        // }}
                        // />

                        <TextField
                          {...input}
                          variant="outlined"
                          fullWidth
                          // select={input.value ? new Date(input.value) : new Date()}
                          name="receivedDate"
                          size="small"
                          type="date"
                          required
                          InputLabelProps={{ shrink: true }}
                        />
                    )}
                    />
                  </FormGroupField>
                </FormGroup>
              </div>
            
                  )}
    
              {/* Creditable Amount - show for all payment types */}
              <div className="col-md-4">
                <FormGroup>
                  <FormGroupLabel>
                    Payment Amount<span style={{ color: 'red' }}>*</span>
                  </FormGroupLabel>
                  <FormGroupField>
                    <Field
                      name="recAmount"
                      placeholder="Enter Amount"
                    >
                      {({ input }) => (
                        <input
                          {...input}
                          type="number"
                          // value={balance}
                        //   onChange={(e) => {
                        //   const newAmount = parseFloat(e.target.value);
                        //   dispatch({
                        //     type: ACTIONS.SET_AMOUNT,
                        //     payload: Number.isNaN(newAmount) ? 0 : newAmount,
                        //   });
                        // }}
                          style={{
                          width: '100%',
                          height: '46px',
                        }}
                        />
                    )}
                    </Field>

                  </FormGroupField>
                </FormGroup>
              </div>
            </>
              )}
          </div>

          {/* Only render additional fields if a payment type is selected */}
          {selectPaymentType && (
          <div className="row col-md-12">
            {/* Narration Field - show for Cash, NEFT/RTGS, and Cheque */}
            {['1', '3', '5'].includes(selectPaymentType.value) && (
            <div className="col-md-12">
              <FormGroup>
                <FormGroupLabel>
                  Narration<span style={{ color: 'red' }}>*</span>
                </FormGroupLabel>
                <FormGroupField>
                  <Field
                    name="narration"
                    component="input"
                    required
                    type="text"
                    style={{
                            width: '100%',
                            height: '46px',
                          }}
                  />
                </FormGroupField>
              </FormGroup>
            </div>
                )}
                
            {/* Reference Number for NEFT/RTGS only (removed for Pay now) */}
            {selectPaymentType.value === '3' && (
            <div className="col-md-4">
              <FormGroup>
                <FormGroupLabel>
                  Ref No<span style={{ color: 'red' }}>*</span>
                </FormGroupLabel>
                <FormGroupField>
                  <Field
                    name="ref"
                    component="input"
                    required
                    type="text"
                    style={{ width: '100%', height: '46px' }}
                  />
                </FormGroupField>
              </FormGroup>
            </div>
                )}
                
            {/* Cheque Ref Number for Cheque payment */}
            {selectPaymentType.value === '5' && (
            <div className="col-md-4">
              <FormGroup>
                <FormGroupLabel>
                  Cheque Ref No<span style={{ color: 'red' }}>*</span>
                </FormGroupLabel>
                <FormGroupField>
                  <Field
                    name="ref"
                    component="input"
                    required
                    type="text"
                    style={{ width: '100%', height: '46px' }}
                  />
                </FormGroupField>
              </FormGroup>
            </div>
                )}
    
            {/* Bank Name for NEFT/RTGS and Cheque */}
            {['3', '5'].includes(selectPaymentType.value) && (
            <div className="col-md-4">
              <FormGroup>
                <FormGroupLabel>
                  Bank Name<span style={{ color: 'red' }}>*</span>
                </FormGroupLabel>
                <FormGroupField>
                  <Field
                    name="bankName"
                    component="input"
                    required
                    type="text"
                    style={{ width: '100%', height: '46px' }}
                  />
                </FormGroupField>
              </FormGroup>
            </div>
                )}
                
            {/* Cheque Date for Cheque */}
            {selectPaymentType.value === '5' && (
            <div className="col-md-4">
              <FormGroup>
                <FormGroupLabel>
                  Cheque Date<span style={{ color: 'red' }}>*</span>
                </FormGroupLabel>
                <FormGroupField>
                  <Field
                    name="chequeDate"
                    render={({ input }) => (
                      <TextField
                        {...input}
                        variant="outlined"
                        fullWidth
                          // select={input.value ? new Date(input.value) : new Date()}
                        name="chequeDate"
                        required
                        size="small"
                        type="date"
                        InputLabelProps={{ shrink: true }}
                      />
                          )}
                  />
                </FormGroupField>
              </FormGroup>
            </div>
                )}
          </div>
            )}
 
          <br />
          <FormButtonToolbar>
            <Button variant="danger" type="button" onClick={() => setShowAddAmountModal(false)}>Close</Button>
            <Button variant="primary" type="submit">
              Add Amount
            </Button>
          </FormButtonToolbar>
        </FormContainer>
        )}
    </Form>
  );
};
 
AddAmount.propTypes = {
  handleAccountSubmit: PropTypes.func.isRequired,
  balance: PropTypes.string.isRequired,
  setShowAddAmountModal: PropTypes.func.isRequired,
};

export default AddAmount;
